// Where each organization's site lives. RESIDENCE users stay on this site.
// Fill in RISE_SITE_URL once the RISE site address is known (for example https://rise.example.com).
export const RISE_SITE_URL = '';
export const ORGANIZATIONS = ['RESIDENCE', 'RISE'];
